import { Gift, Copy } from 'lucide-react';
import { toast } from 'sonner';

const Codigos500Tab = ({ codigos500 }) => (
  <>
    <div className="flex items-center justify-between">
      <h2 className="text-lg font-bold flex items-center gap-2">
        <Gift className="h-5 w-5 text-[#D4AF37]" />
        Codigos de Viaje $500 Reclamados ({codigos500.length})
      </h2>
    </div>

    {codigos500.length === 0 ? (
      <div className="text-center py-10 text-slate-400">
        <Gift className="h-10 w-10 mx-auto mb-3 opacity-50" />
        <p>No hay codigos reclamados aun</p>
      </div>
    ) : (
      <div className="overflow-x-auto rounded-lg border border-slate-200 dark:border-slate-700">
        <table className="w-full">
          <thead>
            <tr className="border-b bg-slate-50 dark:bg-slate-800/60">
              <th className="text-left py-2 px-3 text-xs font-semibold text-slate-500">#</th>
              <th className="text-left py-2 px-3 text-xs font-semibold text-slate-500">Nombre</th>
              <th className="text-left py-2 px-3 text-xs font-semibold text-slate-500">Email</th>
              <th className="text-left py-2 px-3 text-xs font-semibold text-slate-500">Telefono</th>
              <th className="text-left py-2 px-3 text-xs font-semibold text-slate-500">Pais</th>
              <th className="text-left py-2 px-3 text-xs font-semibold text-slate-500">Codigo</th>
              <th className="text-left py-2 px-3 text-xs font-semibold text-slate-500">Fecha</th>
              <th className="text-left py-2 px-3 text-xs font-semibold text-slate-500">Email Enviado</th>
              <th className="text-left py-2 px-3 text-xs font-semibold text-slate-500">Copiar</th>
            </tr>
          </thead>
          <tbody>
            {codigos500.map((c, i) => (
              <tr key={c.id || i} className="border-b border-slate-100 dark:border-slate-700/50 hover:bg-slate-100 dark:hover:bg-slate-800">
                <td className="py-2 px-3 text-xs text-slate-500">{i + 1}</td>
                <td className="py-2 px-3 text-xs font-medium">{c.nombre_cliente}</td>
                <td className="py-2 px-3 text-xs text-slate-500">{c.email_cliente}</td>
                <td className="py-2 px-3 text-xs text-slate-500">{c.telefono_cliente}</td>
                <td className="py-2 px-3 text-xs text-slate-500">{c.pais_cliente}</td>
                <td className="py-2 px-3 text-xs font-mono text-[#D4AF37]">{c.codigo}</td>
                <td className="py-2 px-3 text-xs text-slate-500">{c.reclamado_en ? new Date(c.reclamado_en).toLocaleDateString() : '-'}</td>
                <td className="py-2 px-3 text-xs">
                  {c.email_enviado ? <span className="text-green-500 font-medium">Si</span> : <span className="text-slate-400">No</span>}
                </td>
                <td className="py-2 px-3">
                  <button
                    onClick={() => {
                      const info = `Codigo: ${c.codigo}\nNombre: ${c.nombre_cliente}\nEmail: ${c.email_cliente}\nTelefono: ${c.telefono_cliente}\nPais: ${c.pais_cliente}\nFecha: ${c.reclamado_en || '-'}`;
                      navigator.clipboard.writeText(info);
                      toast.success('Info copiada');
                    }}
                    className="inline-flex items-center gap-1 px-2 py-1 text-[10px] font-semibold bg-[#D4AF37] text-[#1A1A2E] rounded hover:bg-[#B8860B] transition-colors">
                    <Copy className="h-3 w-3" /> Copiar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </>
);

export default Codigos500Tab;
